import { render, staticRenderFns } from "./componentColor.vue?vue&type=template&id=26721cad&scoped=true&lang=pug"
import script from "./componentColor.vue?vue&type=script&lang=js"
export * from "./componentColor.vue?vue&type=script&lang=js"
import style0 from "@/CommonDP/mongeView/common/common.scss?vue&type=style&index=0&id=26721cad&prod&lang=scss&scoped=true&external"
import style1 from "./componentColor.vue?vue&type=style&index=1&id=26721cad&prod&lang=scss&scoped=true"
import style2 from "./componentColor.vue?vue&type=style&index=2&id=26721cad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26721cad",
  null
  
)

export default component.exports